import React, { Component } from 'react'
import TimeField from 'vendor/time-field'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import DateContainer from 'components/date-container/date-container'
import { debounce } from 'lodash'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import moment from 'moment'

import {
    searchTasks,
    addManualSession,
    openModal
} from 'state/actions'
import { getCurrentAccount } from 'state/selectors'

import {
    getSessionsFromTimeInput
} from 'utils'

class ModalAddTime extends Component {
    state = {
        taskNameTextValue: '',
        timeValue: '',
        searchResults: [],
        selectedItemId: null,
        selectedDate: moment(),
        isDatePickerOpen: false
    }

	constructor(props){
		super(props)

		this.debouncedSearchTasks = debounce(this.searchTasks, 300)
	}

    handleChange = (value, key) => {
        this.setState({
            [key]: value
        })
    }

    searchTasks = value => {
        const { searchTasks, currentAccount } = this.props

        if(value.length > 2){
            searchTasks(currentAccount.id, value, searchResults => {
                const includedProjectIds = Object.keys(window.allIncludedProjects)

                const visibleTasks = searchResults.filter(task => {
                    return ~includedProjectIds.indexOf(task.project_id+'')
                })

                this.setState({
                    searchResults: visibleTasks
                })
            })
        }
    }

    selectTask = taskId => {
        this.setState({
            selectedItemId: taskId
        })
    }

    selectDate = day => {
        this.setState({
            selectedDate: moment(day),
            isDatePickerOpen: false
        })
    }

    handleSubmit = _ => {
        const {
            setLoading,
            addManualSession,
            data,
            openModal
        } = this.props

        const {
            timeValue,
            selectedItemId,
            selectedDate
        } = this.state

        const totalSeconds = getSessionsFromTimeInput(timeValue)

        const isTaskMode = !!data.taskId
        const taskId = isTaskMode ? data.taskId : selectedItemId
        const date = isTaskMode ? selectedDate : data.date

        setLoading(true)

        addManualSession(taskId, totalSeconds, date.format('YYYY-MM-DD'), () => {
			openModal('confirm', 'confirm', {
				text: `We've added this time-tracking session in for you.`
			})
            setLoading(false)
        })
    }

    handleSearchTermChange = value => {
        this.debouncedSearchTasks(value)
    }

    canSubmit = _ => {
        const { data } = this.props
        const { timeValue, selectedItemId } = this.state

        const isTaskMode = !!data.taskId
        const hasTask = isTaskMode || !!selectedItemId

        return hasTask && timeValue && timeValue !== '00:00'
    }

    render() {
        const {
            timeValue,
            searchResults,
            selectedItemId,
            selectedDate,
            isDatePickerOpen
        } = this.state

        const {
            closeCallback,
            data
        } = this.props

        const isTaskMode = !!data.taskId

        return (
			<div>
                <h2>
                    Add manual time
                </h2>
				<div className={'borders'}>
                    { !isTaskMode &&
                        <div>
                            <DropdownMenu
                                parentType="task"
                                parentKey="task_id"
                                selectableItems={searchResults}
                                isObjects={true}
                                selectedItemId={selectedItemId}
                                handleChange={this.selectTask}
                                handleSearchTermChange={this.handleSearchTermChange}
                                hasSearch={true}
                                subLabel={task => {
                                    const project = window.allIncludedProjects && window.allIncludedProjects[task.project_id]
                                    return project ? project.name : null
                                }}
                            />
                        </div>
                    }
                    { isTaskMode &&
                        <DateContainer
                            isEdit={true}
                            isOpen={isDatePickerOpen}
                            toggleCallback={() => this.setState({ isDatePickerOpen: !isDatePickerOpen })}
                            closeCallback={() => this.setState({ isDatePickerOpen: false })}
                            selectCallback={this.selectDate}
                            selectedDate={selectedDate}
                            allowPast={true}
                            showTodayInLabel={true}
                            label={'Select date'}
                        />
                    }
					<TimeField
						onChange={value => this.handleChange(value, 'timeValue')}
						value={timeValue}
                        placeholder={'00:00'}
						colon=":"
					/>
                </div>
				<Button
					size={'big'}
					level={'high'}
					callback={this.handleSubmit}
					label={'Save'}
					icon={'check'}
					disabled={!this.canSubmit()}
				/>
				<Button
					size={'big'}
					level={'low'}
					callback={closeCallback}
					label={'Cancel'}
				/>
            </div>
        )
    }
}



const mapStateToProps = state => {
	return {
        currentAccount: getCurrentAccount(state),
    }
}

export default connect(mapStateToProps, {
    searchTasks,
    addManualSession,
    openModal
})(ModalAddTime)